// Admin auth token storage. Uses localStorage for simplicity — JWTs expire
// in 7 days server-side so a stale token just triggers a re-login.
const KEY = "zca_admin_token";
const KEY_USER = "zca_admin_user";

export function saveAdminAuth({ token, email, full_name, role }) {
  localStorage.setItem(KEY, token);
  localStorage.setItem(KEY_USER, JSON.stringify({ email, full_name, role }));
}

export function getAdminToken() {
  return localStorage.getItem(KEY) || "";
}

export function getAdminUser() {
  try {
    return JSON.parse(localStorage.getItem(KEY_USER) || "null");
  } catch {
    return null;
  }
}

export function clearAdminAuth() {
  localStorage.removeItem(KEY);
  localStorage.removeItem(KEY_USER);
}
